import { Component, OnInit, OnDestroy } from '@angular/core';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { EVENT_EMITTERS, PATHS } from '../../../analytics/constants/analytics.constants';
import * as _ from 'underscore';
import * as Highcharts from 'highcharts';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { DailyStatsComponent } from '../daily-stats/daily-stats.component';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import * as HighchartsBorderRadius from 'highcharts-rounded-corners';
HighchartsBorderRadius(Highcharts);
import { SeriesConfig, DailyStatsMetricConfig } from '../../../analytics-core/interfaces/chart.interface';

@Component({
	selector: 'app-performance-by-day-display-v6',
	templateUrl: './performance-by-day-display-v6.component.html',
	styleUrls: ['./performance-by-day-display-v6.component.css']
})
export class PerformanceByDayDisplayV6Component extends DailyStatsComponent implements OnInit, WidgetCore, OnDestroy {
	public completionRates: any = [];
	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected colorUtilityService: ColorUtilityService
	) {
		super(analyticsService, analyticsDataModel, colorUtilityService);
	}

	ngOnInit() {
		this.colorsconfig = JSON.parse(decodeURI(this.colorsconfig));
		super.ngOnInit();
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	generateChartObj() {
		const isCtv = this.analyticsDataModel.getCurrentPath() === PATHS.CTV;
		const isGeoVideo = this.analyticsDataModel.getCurrentPath() === PATHS.GEOVIDEO;
		const isPreroll = this.analyticsDataModel.getCurrentPath() === PATHS.PREROLL;
		const isRadio = this.analyticsDataModel.getCurrentPath() === PATHS.RADIO;
		// tslint:disable-next-line: no-this-assignment
		const self = this;
		Highcharts.chart('chartElement', {
			chart: {
				margin: [60, 50, 30, 45],
				style: {
					fontFamily: 'Montserrat'
				}
			},
			title: {
				text: null
			},
			subtitle: {
				text: null
			},
			xAxis: {
				offset: 5,
				categories: this.graphObj.categories,
				labels: {
					step: this.graphObj.stepCount,
					style: {
						color: '#262626',
						fontSize: '12px'
					},
					useHTML: true,
					formatter: function () {
						return `<span class='xlabel'>` + this.value + `<span>`;
					}
				},

				lineWidth: 0,
				minorGridLineWidth: 0,
				gridLineColor: 'transparent',
				lineColor: 'transparent',
				minorTickLength: 0,
				tickLength: 0
			},
			yAxis: {
				allowDecimals: false,
				labels: {
					enabled: true,
					align: 'left',
					style: {
						fontFamily: 'Lora !important',
						fontStyle: 'italic !important',
						color: '#262626',
						'font-size': '12px'
					},
					useHTML: true,
					formatter: function () {
						if (this.value >= 1000) {
							return `<span class='xlabel'>` + Number(this.value) / 1000 + `k<span>`;
						} else {
							return `<span class='xlabel'>` + this.value + `<span>`;
						}
					}
				},
				offset: 20,
				title: {
					text: ''
				},
				gridLineColor: 'transparent',
				stackLabels: {
					enabled: false,
					style: {
						fontWeight: 'bold',
						color: 'gray'
					}
				}
			},
			credits: {
				enabled: false
			},
			plotOptions: {
				column: {
					stacking: 'normal',
					events: {
						legendItemClick: function () {
							let self = this;
							Highcharts.each(this.chart.series, (series, index) => {
								if (this.name === series.name) {
									this.chart.series[index].show();
								} else if (series.visible) {
									this.chart.series[index].hide();
								}
							});
							return false;
						}
					},
					pointWidth: this.getWidth()
				},
				series: {
					borderWidth: 0
				}
			},
			legend: {
				layout: 'horizontal',
				width: 1300,
				align: 'left',
				verticalAlign: 'top',
				floating: false,
				x: -6,
				y: -15,
				margin: 20,
				symbolPadding: 0,
				symbolWidth: 0,
				symbolRadius: 0,
				labelFormatter: function () {
					return this.name.toUpperCase();
				},
				itemMarginBottom: 30,
				itemDistance: 30,
				itemStyle: {
					'font-size': '16px',
					'font-weight': '600',
					color: '#262626'
				},
				itemHiddenStyle: {
					'font-weight': '600',
					color: '#d8d8d8'
				},
				itemHoverStyle: {
					'font-weight': '600',
					color: '#d8d8d8'
				}
			},
			tooltip: {
				shared: false,
				borderColor: 'rgba(221, 225, 227, 0.75)',
				backgroundColor: '#f7f7f7',
				borderRadius: 4,
				borderWidth: 0,
				useHTML: true,
				formatter: function () {
					if ((isCtv || isGeoVideo || isPreroll || isRadio) && this.series.name === 'Completions') {
						return `<div class="legendClass">
							<table class="table">
								<tr style="color: ${this.color} !important"><td class="tooltipDate tooltipRow"><b>${this.x}</b></td></tr>
								<tr><td class="tooltipRow"><b>${this.point.y.toLocaleString()} | ${self
							.getCompletionRate(this.point.index)
							.toFixed(2)}% </b></td></tr>
								<tr><td class="tooltipRow"><b>${this.series.name.toUpperCase()}</b></td></tr>
							</table>
						</div>`;
					} else if (this.series.name.toLowerCase() === 'keyword search impressions') {
						return `<div class="legendClass">
							<table class="table">
								<tr style="color: ${this.color} !important"><td class="tooltipDate tooltipRow"><b>${this.x}</b></td></tr>
								<tr><td class="tooltipRow"><b>${this.point.y.toLocaleString()} </b></td></tr>
								<tr><td class="tooltipRow"><b>KEYWORD SEARCH</br>TARGETING IMPRESSIONS</b></td></tr>
							</table>
						</div>`;
					} else {
						return `<div class="legendClass">
						<table class="table">
							<tr style="color: ${this.color} !important"><td class="tooltipDate tooltipRow"><b>${this.x}</b></td></tr>
							<tr><td class="tooltipRow"><b>${this.point.y.toLocaleString()} </b></td></tr>
							<tr><td class="tooltipRow"><b>${this.series.name.toUpperCase()}</b></td></tr>
						</table>
					</div>`;
					}
				}
			},
			series: this.updateBorders(this.graphObj.series)
		});
		this.dynamicWidth();
	}

	updateBorders(series) {
		for (let i = 0; i < series.length; i++) {
			series[i]['borderRadiusTopLeft'] = '50%';
			series[i]['borderRadiusTopRight'] = '50%';
			series[i]['borderRadiusBottomLeft'] = '50%';
			series[i]['borderRadiusBottomRight'] = '50%';
		}
		return series;
	}

	buildChartSeriesObj() {
		const chartSeries: any = [];
		const totalImpressions = _.pluck(this.dailyStats, 'totalImpressions');
		const rtgImpressions = _.pluck(this.dailyStats, 'rtgImpressions');
		const engagements = _.pluck(this.dailyStats, 'engagements');
		const totalVisits = _.pluck(this.dailyStats, 'totalVisits');
		const totalClicks = _.pluck(this.dailyStats, 'totalClicks');
		const completions = _.pluck(this.dailyStats, 'completions');
		const completionRate = _.pluck(this.dailyStats, 'completionRate');
		const keywordImpressions = _.pluck(this.dailyStats, 'keywordImpressions');
		const offlineVisits = _.pluck(this.dailyStats, 'offlineVisits');
		this.completionRates = _.pluck(this.dailyStats, 'completionRate');

		// iF CONFIG NOT EXISTS THEN MANUALLY PROCESS THE CHART OBJECT
		if (_.isEmpty(this.chartconfiguration)) {
			const engagementsObj: any = {};
			engagementsObj.type = 'column';
			engagementsObj.name = 'Engagements';
			engagementsObj.data = engagements;
			engagementsObj.color = this.colorPalette.primaryColor;
			engagementsObj.fillOpacity = 0.4;
			engagementsObj.opposite = true;
			engagementsObj.legendIndex = 4;
			engagementsObj.maxPointWidth = 50;
			engagementsObj.visible = false;
			engagementsObj.marker = {
				symbol: 'square'
			};

			const completionsObj: any = {};
			completionsObj.type = 'column';
			completionsObj.name = 'Completions';
			completionsObj.data = completions;
			completionsObj.color = this.colorPalette.primaryColor;
			completionsObj.completionRate = completionRate;
			completionsObj.fillOpacity = 0.4;
			completionsObj.opposite = true;
			completionsObj.legendIndex = 4;
			completionsObj.maxPointWidth = 50;
			completionsObj.visible = false;
			completionsObj.marker = {
				symbol: 'square'
			};

			const clicksObj: any = {};
			clicksObj.type = 'column';
			clicksObj.name = 'Clicks';
			clicksObj.data = totalClicks;
			clicksObj.color = this.colorPalette.primaryColor;
			clicksObj.fillOpacity = 0.4;
			clicksObj.opposite = true;
			clicksObj.legendIndex = 2;
			clicksObj.visible = false;
			clicksObj.maxPointWidth = 50;
			clicksObj.marker = {
				symbol: 'square'
			};

			const visitsObj: any = {};
			visitsObj.type = 'column';
			visitsObj.name = 'Visits';
			visitsObj.data = totalVisits;
			visitsObj.color = this.colorPalette.primaryColor;
			visitsObj.fillOpacity = 0.4;
			visitsObj.opposite = true;
			visitsObj.legendIndex = 3;
			visitsObj.visible = false;
			visitsObj.maxPointWidth = 50;
			visitsObj.marker = {
				symbol: 'square'
			};

			const totalImpressionsObj: any = {};
			totalImpressionsObj.type = 'column';
			totalImpressionsObj.name = 'Impressions';
			totalImpressionsObj.data = totalImpressions;
			totalImpressionsObj.color = this.colorPalette.primaryColor;
			totalImpressionsObj.fillOpacity = 0.4;
			totalImpressionsObj.visible = true;
			totalImpressionsObj.legendIndex = 1;
			totalImpressionsObj.marker = {
				symbol: 'square'
			};

			const rtgImpressionsObj: any = {};
			rtgImpressionsObj.type = 'column';
			rtgImpressionsObj.name = 'RTG Impressions';
			rtgImpressionsObj.data = rtgImpressions;
			rtgImpressionsObj.color = this.colorPalette.primaryColor;
			rtgImpressionsObj.visible = false;
			rtgImpressionsObj.fillOpacity = 0.4;
			rtgImpressionsObj.legendIndex = 5;
			rtgImpressionsObj.marker = {
				symbol: 'square'
			};

			const keywordImpressionsObj: any = {};
			keywordImpressionsObj.type = 'column';
			keywordImpressionsObj.name = 'Keyword Search Impressions';
			keywordImpressionsObj.data = keywordImpressions;
			keywordImpressionsObj.color = this.colorPalette.primaryColor;
			keywordImpressionsObj.visible = false;
			keywordImpressionsObj.fillOpacity = 0.4;
			keywordImpressionsObj.legendIndex = 5;
			keywordImpressionsObj.marker = {
				symbol: 'square'
			};

			const offlineVisitsObj: any = {};
			offlineVisitsObj.type = 'column';
			offlineVisitsObj.name = 'Offline Visits';
			offlineVisitsObj.data = offlineVisits;
			offlineVisitsObj.color = this.colorPalette.primaryColor;
			offlineVisitsObj.visible = false;
			offlineVisitsObj.fillOpacity = 0.4;
			offlineVisitsObj.legendIndex = 8;
			offlineVisitsObj.marker = {
				symbol: 'square'
			};

			if (this.analyticsDataModel.getCurrentPath() === PATHS.DISPLAY) {
				chartSeries.push(totalImpressionsObj);
				chartSeries.push(rtgImpressionsObj);
				chartSeries.push(visitsObj);
				chartSeries.push(engagementsObj);
				chartSeries.push(clicksObj);
				chartSeries.push(keywordImpressionsObj);
			} else if (this.analyticsDataModel.getCurrentPath() === PATHS.PREROLL) {
				chartSeries.push(totalImpressionsObj);
				chartSeries.push(clicksObj);
				chartSeries.push(visitsObj);
				chartSeries.push(completionsObj);
				chartSeries.push(rtgImpressionsObj);
				chartSeries.push(keywordImpressionsObj);
			} else if (this.analyticsDataModel.getCurrentPath() === PATHS.GEOVIDEO) {
				chartSeries.push(totalImpressionsObj);
				chartSeries.push(clicksObj);
				chartSeries.push(completionsObj);
				chartSeries.push(rtgImpressionsObj);
				chartSeries.push(offlineVisitsObj);
			} else if (this.analyticsDataModel.getCurrentPath() === PATHS.SEM) {
				chartSeries.push(totalImpressionsObj);
				chartSeries.push(clicksObj);
			} else if (this.analyticsDataModel.getCurrentPath() === PATHS.CTV) {
				chartSeries.push(totalImpressionsObj);
				chartSeries.push(completionsObj);
			} else if (this.analyticsDataModel.getCurrentPath() === PATHS.SOCIAL) {
				chartSeries.push(totalImpressionsObj);
				chartSeries.push(clicksObj);
			} else if (this.analyticsDataModel.getCurrentPath() === PATHS.RADIO) {
				chartSeries.push(totalImpressionsObj);
				rtgImpressionsObj.legendIndex = 2;
				chartSeries.push(rtgImpressionsObj);
				completionsObj.legendIndex = 3;
				chartSeries.push(completionsObj);
			} else if (this.analyticsDataModel.getCurrentPath() === PATHS.GAM) {
				chartSeries.push(totalImpressionsObj);
				chartSeries.push(clicksObj);
			} else {
				chartSeries.push(totalImpressionsObj);
				chartSeries.push(rtgImpressionsObj);
				chartSeries.push(clicksObj);
				chartSeries.push(offlineVisitsObj);
			}
			// ELSE iF CONFIG  EXISTS THEN PROCESS THE CHART OBJECT USING CONFIG
		} else if (!_.isEmpty(this.chartconfiguration)) {
			// check for permission
			let seriesConfig: SeriesConfig[] = this.chartconfiguration.seriesConfig;
			seriesConfig = _.filter(seriesConfig, (config) => {
				return this.analyticsDataModel.checkComponentForPermission(config);
			});
			for (const stat of seriesConfig) {
				const metricObj: DailyStatsMetricConfig = {} as DailyStatsMetricConfig;
				metricObj.type = stat.type;
				metricObj.name = stat.seriesName;
				metricObj.data = _.pluck(this.dailyStats, stat.tooltipInfo[0].key);
				metricObj.color = this.colorUtilityService.getHEXByColorType(
					this.colorPalette,
					this.statsColors[stat.colorConfig.color],
					1
				);
				metricObj.visible = stat.visible;
				metricObj.fillOpacity = stat.fillOpacity;
				metricObj.legendIndex = stat.legendIndex;
				metricObj.marker = stat.marker;
				chartSeries.push(metricObj);
			}
		}
		return chartSeries;
	}

	buildCategoriesObj() {
		const datesParsed = this.dailyStats.map((stat) => {
			let tempDate = new Date(stat.date);
			return `${tempDate.getMonth() + 1}/${tempDate.getDate()}`;
		});
		return datesParsed;
	}

	calculateStepCount() {
		const dataLength = this.dailyStats.length;
		if (dataLength <= 31) {
			return 1;
		} else if (dataLength <= 300 && dataLength >= 200) {
			return 10;
		} else if (dataLength >= 300) {
			return 25;
		} else {
			return 5;
		}
	}

	getWidth() {
		if (this.dailyStats.length <= 31) {
			return 36;
		} else {
			return undefined;
		}
	}

	downloadDataInCSV(event: any) {
		event.preventDefault();
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey,
			this.downloadConfiguration.fileName,
			this.downloadcsvcolumns,
			null,
			this.newTabXLSXRequired ? this.downloadConfiguration.newTabCsvQueryKey : '',
			this.newTabXLSXRequired ? this.downloadConfiguration.newTabCsvFileName : ''
		);
	}

	getCompletionRate(index) {
		return this.completionRates[index];
	}
}
